import React from "react";
import { FunctionField, ReferenceField } from "react-admin";
import { Typography } from "@material-ui/core";

interface IPassengerUpdatedByField {
  data: IUpdatedBy;
  record?: any;
}

const PassengerUpdatedByField = ({
  data,
  record = {},
}: IPassengerUpdatedByField) => {
  const updatedBySystemFormatter = (role: string): string => {
    switch (role) {
      case "Cca":
        return "System - CCA Trip";
      default:
        return role;
    }
  };

  if (data) {
    switch (data.role) {
      case "Parent":
        return (
          <ReferenceField
            reference="parents"
            source="updatedBy.id"
            link={false}
            record={record}
          >
            <FunctionField
              render={(record: any) => (
                <Typography variant="caption">
                  {data.role} - {record.firstName} {record.lastName}
                </Typography>
              )}
            />
          </ReferenceField>
        );

      case "Admin":
        return (
          <ReferenceField
            reference="admins"
            source="updatedBy.id"
            link={false}
            record={record}
          >
            <FunctionField
              render={(record: any) => (
                <Typography variant="caption">
                  {data.role} - {record.fullName}
                </Typography>
              )}
            />
          </ReferenceField>
        );

      case "Driver":
        return (
          <ReferenceField
            reference="drivers"
            source="updatedBy.id"
            link={false}
            record={record}
          >
            <FunctionField
              render={(record: any) => (
                <Typography variant="caption">
                  {data.role} - {record.fullName}
                </Typography>
              )}
            />
          </ReferenceField>
        );

      case "Assistant":
        return (
          <ReferenceField
            reference="busAssistants"
            source="updatedBy.id"
            link={false}
            record={record}
          >
            <FunctionField
              render={(record: any) => (
                <Typography variant="caption">
                  Bus Assistant - {record.fullName}
                </Typography>
              )}
            />
          </ReferenceField>
        );

      default:
        return (
          <Typography variant="caption">
            {updatedBySystemFormatter(data.role)}
          </Typography>
        );
    }
  }

  return <></>;
};

export default PassengerUpdatedByField;
